import { API_BASE } from '../../constants';

const encode = (value) => encodeURIComponent(value);

// Percent-encode a single dynamic path segment. Centralized so every endpoint
// path is built the same safe way.
export const encodeSegment = encode;

// Build a query string from a params object: omits null/undefined/empty-string
// values, encodes keys and values, and preserves insertion order. Returns ''
// when no params remain, otherwise a leading-'?' string.
export const buildQuery = (params = {}) => {
    const pairs = Object.entries(params)
        // eslint-disable-next-line no-undefined
        .filter(([, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${encode(key)}=${encode(value)}`);

    return pairs.length > 0 ? `?${pairs.join('&')}` : '';
};

// Join the API base, an endpoint path, and an optional query object into a
// single clean URL. `path` is expected to begin with '/' and already have any
// dynamic segments encoded (see encodeSegment / PATHS).
export const buildUrl = (path, params) => `${API_BASE}${path}${params ? buildQuery(params) : ''}`;
